import { FormAlert } from '@/components/public/forms/FormAlert';

export type ErrorSummaryItem = {
  key: string;
  label: string;
  message: string;
  href?: string;
  onClick?: () => void;
};

type ErrorSummaryProps = {
  title?: string;
  intro?: string;
  items: ErrorSummaryItem[];
};

export function ErrorSummary({
  title = 'Há dados por corrigir antes da submissão',
  intro = 'Reveja os campos assinalados. O pedido ainda não foi enviado.',
  items,
}: ErrorSummaryProps) {
  if (items.length === 0) return null;

  return (
    <FormAlert variant="error" title={title}>
      <p>{intro}</p>
      <ul className="mt-2 list-disc space-y-1 pl-5 text-sm">
        {items.map((item) => (
          <li key={item.key}>
            {item.onClick ? (
              <button
                type="button"
                onClick={item.onClick}
                className="text-error cursor-pointer p-0 text-left font-semibold underline"
              >
                {item.label}
              </button>
            ) : item.href ? (
              <a href={item.href} className="text-error font-semibold underline">
                {item.label}
              </a>
            ) : (
              <span className="text-on-surface font-semibold">{item.label}</span>
            )}
            : {item.message}
          </li>
        ))}
      </ul>
    </FormAlert>
  );
}
